import React from 'react';

export const SearchIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.7549 14.2549H14.9649L14.6849 13.9849C15.6649 12.8449 16.2549 11.3649 16.2549 9.75488C16.2549 6.16488 13.3449 3.25488 9.75488 3.25488C6.16488 3.25488 3.25488 6.16488 3.25488 9.75488C3.25488 13.3449 6.16488 16.2549 9.75488 16.2549C11.3649 16.2549 12.8449 15.6649 13.9849 14.6849L14.2549 14.9649V15.7549L19.2549 20.7449L20.7449 19.2549L15.7549 14.2549ZM9.75488 14.2549C7.26488 14.2549 5.25488 12.2449 5.25488 9.75488C5.25488 7.26488 7.26488 5.25488 9.75488 5.25488C12.2449 5.25488 14.2549 7.26488 14.2549 9.75488C14.2549 12.2449 12.2449 14.2549 9.75488 14.2549Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const DocumentIcon = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13 2.83325L12 1.83325L11 2.83325L10 1.83325L9 2.83325L8 1.83325L7 2.83325L6 1.83325L5 2.83325L4 1.83325L3 2.83325L2 1.83325V15.1666L3 14.1666L4 15.1666L5 14.1666L6 15.1666L7 14.1666L8 15.1666L9 14.1666L10 15.1666L11 14.1666L12 15.1666L13 14.1666L14 15.1666V1.83325L13 2.83325ZM12.6667 13.2266H3.33333V3.77325H12.6667V13.2266ZM4 10.4999H12V11.8333H4V10.4999ZM4 7.83325H12V9.16659H4V7.83325ZM4 5.16658H12V6.49992H4V5.16658Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const PeopleIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.66675 5.33329C8.66675 6.80663 7.47341 7.99996 6.00008 7.99996C4.52675 7.99996 3.33341 6.80663 3.33341 5.33329C3.33341 3.85996 4.52675 2.66663 6.00008 2.66663C7.47341 2.66663 8.66675 3.85996 8.66675 5.33329ZM7.33341 5.33329C7.33341 4.59996 6.73341 3.99996 6.00008 3.99996C5.26675 3.99996 4.66675 4.59996 4.66675 5.33329C4.66675 6.06663 5.26675 6.66663 6.00008 6.66663C6.73341 6.66663 7.33341 6.06663 7.33341 5.33329ZM12.6667 5.33329C12.6667 6.80663 11.4734 7.99996 10.0001 7.99996C9.68675 7.99996 9.39341 7.93329 9.11341 7.83996C9.66675 7.15329 10.0001 6.27996 10.0001 5.33329C10.0001 4.38663 9.66675 3.51329 9.11341 2.82663C9.39341 2.73329 9.68675 2.66663 10.0001 2.66663C11.4734 2.66663 12.6667 3.85996 12.6667 5.33329ZM12.6667 11.3333C12.6667 10.2133 12.0267 9.37329 11.1134 8.75329C12.9534 9.01996 15.3334 9.87996 15.3334 11.3333V13.3333H12.6667V11.3333ZM6.00008 8.66663C4.22008 8.66663 0.666748 9.55996 0.666748 11.3333V13.3333H11.3334V11.3333C11.3334 9.55996 7.78008 8.66663 6.00008 8.66663ZM2.00008 12V11.34C2.13341 10.86 4.20008 9.99996 6.00008 9.99996C7.80008 9.99996 9.86675 10.86 10.0001 11.3333V12H2.00008Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const PaymentIcon = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.3333 3.16675H2.66659C1.92659 3.16675 1.33992 3.76008 1.33992 4.50008L1.33325 12.5001C1.33325 13.2401 1.92659 13.8334 2.66659 13.8334H13.3333C14.0733 13.8334 14.6666 13.2401 14.6666 12.5001V4.50008C14.6666 3.76008 14.0733 3.16675 13.3333 3.16675ZM13.3333 12.5001H2.66659V8.50008H13.3333V12.5001ZM13.3333 5.83341H2.66659V4.50008H13.3333V5.83341Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const ScheduleIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16px"
      height="16px"
      viewBox="0 -1 12 16"
    >
      <path
        fill="currentColor"
        d="M 5.246094 8.484375 L 5.648438 8.082031 L 4.917969 7.351562 L 4.515625 7.753906 C 4.285156 7.597656 4.023438 7.488281 3.738281 7.410156 L 3.738281 6.8125 L 2.449219 6.8125 L 2.449219 7.410156 C 2.160156 7.488281 1.898438 7.601562 1.65625 7.765625 L 1.273438 7.382812 L 0.539062 8.105469 L 0.9375 8.503906 C 0.785156 8.730469 0.671875 8.984375 0.601562 9.261719 L 0 9.261719 L 0 10.550781 L 0.597656 10.550781 C 0.675781 10.832031 0.785156 11.097656 0.941406 11.328125 L 0.539062 11.730469 L 1.269531 12.460938 L 1.671875 12.058594 C 1.90625 12.214844 2.167969 12.324219 2.453125 12.402344 L 2.453125 13 L 3.734375 13 L 3.734375 12.402344 C 4.011719 12.328125 4.269531 12.214844 4.496094 12.0625 L 4.917969 12.484375 L 5.648438 11.753906 L 5.234375 11.347656 C 5.398438 11.101562 5.511719 10.839844 5.589844 10.546875 L 6.1875 10.546875 L 6.1875 9.265625 L 5.589844 9.265625 C 5.515625 8.980469 5.402344 8.71875 5.246094 8.484375 Z M 3.09375 10.964844 C 2.511719 10.964844 2.035156 10.488281 2.035156 9.90625 C 2.035156 9.316406 2.511719 8.847656 3.09375 8.847656 C 3.683594 8.847656 4.152344 9.316406 4.152344 9.90625 C 4.152344 10.488281 3.683594 10.964844 3.09375 10.964844 Z M 3.09375 10.964844 "
      />
      <path
        fill="currentColor"
        d="M 10.289062 1.085938 L 10.289062 0 L 9.210938 0 L 9.210938 1.085938 L 3.789062 1.085938 L 3.789062 0 L 2.710938 0 L 2.710938 1.085938 L 0 1.085938 L 0 6.425781 L 1.085938 6.425781 L 1.085938 5.390625 L 11.914062 5.390625 L 11.914062 11.914062 L 6.558594 11.914062 L 6.558594 13 L 13 13 L 13 1.085938 Z M 11.914062 4.304688 L 1.085938 4.304688 L 1.085938 2.164062 L 2.710938 2.164062 L 2.710938 3.25 L 3.789062 3.25 L 3.789062 2.164062 L 9.210938 2.164062 L 9.210938 3.25 L 10.289062 3.25 L 10.289062 2.164062 L 11.914062 2.164062 Z M 11.914062 4.304688 "
      />
    </svg>
  );
};
